import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DefaultFiltersState } from '@/stores'
import { SetFilterValue } from '@/stores/shared.ts'

export interface B2cOneTimePaymentsTableState extends DefaultFiltersState {}

const initialState: B2cOneTimePaymentsTableState = {
  page: 0,
  showCount: 10,
}

const b2cOneTimePaymentsSlice = createSlice({
  name: 'b2cOneTimePayments',
  initialState,
  selectors: {
    filters: (state) => ({ page: state.page, showCount: state.showCount, sort: state.sort }),
  },
  reducers: {
    setFilter: (state, action: PayloadAction<SetFilterValue<B2cOneTimePaymentsTableState>>) => {
      return {
        ...state,
        page: action.payload.filterKey !== 'page' ? 0 : state.page,
        [action.payload.filterKey]: action.payload.filterValue,
      }
    },
    resetFilters: (state, action: PayloadAction<(keyof B2cOneTimePaymentsTableState)[]>) => {
      const patch = Object.fromEntries(action.payload.map((key) => [key, initialState[key]]))
      return { ...state, ...patch }
    },
  },
})

export const {
  reducer: b2cOneTimePaymentsReducer,
  selectors: b2cOneTimePaymentsSelectors,
  actions: b2cOneTimePaymentsActions,
} = b2cOneTimePaymentsSlice
